import { useNavigate } from "@tanstack/react-router";
import { IconArrowLeft, IconPlus } from "@tabler/icons-react";
import { AdminPageHeader, Button, Group } from "@/components/ui";

export function EquivalenciasHeader({
  total,
  modoCrear,
  onIniciarCrear,
}: {
  total: number;
  modoCrear: boolean;
  onIniciarCrear: () => void;
}) {
  const navigate = useNavigate();
  return (
    <AdminPageHeader
      title="Equivalencias de unidad SAT ↔ SAP"
      description={`${total} equivalencias · relacionan la clave de unidad del CFDI (SAT) con la unidad de SAP para conciliar las solicitudes tipo Orden de Compra.`}
      actions={
        <Group gap="xs">
          <Button variant="default" leftSection={<IconArrowLeft size={14} />} onClick={() => void navigate({ to: "/admin" })}>
            Volver
          </Button>
          {!modoCrear ? (
            <Button leftSection={<IconPlus size={14} />} onClick={onIniciarCrear}>
              Nueva equivalencia
            </Button>
          ) : null}
        </Group>
      }
    />
  );
}
